import React from 'react';
import {CONVERTABLE,FILE_GROUPS,FILE_TYPES,GROUP_ICONS} from '../constants/Fixtures';
import _ from 'lodash';
import coreFileTypes from '../constants/file_types';
import ancillaryFileTypes from '../constants/file_type_ancillary';

export const allFileTypes = _.merge(
  _.map(coreFileTypes, _.clone),
  _.map(ancillaryFileTypes, _.clone)
);

export const groupForFile = function(file) {
  return FILE_GROUPS[file.type] || file.type;
};

export const iconForGroup = function(group) {
  let icon = GROUP_ICONS[group];
  let className = 'fa fa-' + icon;
  return <i className={className}></i>;
};

export const isConvertable = function(fileType) {
  return CONVERTABLE.indexOf(fileType) > -1;
};

export const getFileTypeName = function(slug) {
  return FILE_TYPES[slug] || slug;
};

export const conversionOutput = function(inputSlug, outputSlug) {
  if (inputSlug === 'docx' && outputSlug === 'docx') {
    return 'Refined ' + getFileTypeName(outputSlug);
  } else if (inputSlug === 'scml' && outputSlug === 'scml') {
    return 'Reprocessed ' + getFileTypeName(outputSlug);
  } else if (outputSlug.toLowerCase().includes('epub')) {
    return getFileTypeName(outputSlug);
  } else {
    return getFileTypeName(outputSlug);
  }
};

export const fileExtension = function(name) {
  return name.split('.').pop();
};

const UPLOADABLE_TYPES = _.filter(coreFileTypes, (ft) => ft.uploadable);

const UPLOADABLE_MIMETYPES = _.chain(UPLOADABLE_TYPES).map('mime_type').uniq().value();

const UPLOADABLE_EXTENSIONS = _.chain(UPLOADABLE_TYPES).map('ext').value();

export const isUploadable = function(file) {
  if (!!file.type && UPLOADABLE_MIMETYPES.indexOf(file.type) > -1) {
    return true;
  } else if (!!file.name && UPLOADABLE_EXTENSIONS.indexOf(fileExtension(file.name)) > -1) {
    return true;
  } else {
    return false;
  }
};

const IMAGE_TYPES = _.filter(coreFileTypes, (ft) => ft.group === 'image');
const IMAGE_MIMETYPES = _.map(IMAGE_TYPES, 'mime_type');
const IMAGE_EXTENSIONS = _.map(IMAGE_TYPES, 'ext');

export const isImage = function(file) {
  if (!!file.type && IMAGE_MIMETYPES.indexOf(file.type) > -1) {
    return true;
  } else if (!!file.name && IMAGE_EXTENSIONS.indexOf(fileExtension(file.name)) > -1) {
    return true;
  } else {
    return false;
  }
}

export const isTypeOf = function(type, file) {
  const types = _.filter(allFileTypes, (ft) => ft.group === type);
  const mimetypes = _.map(types, 'mime_type');
  const extensions = _.map(types, 'ext');
  if (!!file.type && mimetypes.indexOf(file.type) > -1) {
    return true;
  } else if (!!file.name && extensions.indexOf(fileExtension(file.name)) > -1) {
    return true;
  } else {
    return false;
  }
}

// this skips the file if no files are processed or this file is not processed;
// if it is to be processed, it merges the local settings with the global in order
// of precedence
export const mergeFileSettings = function(settings, file, globalImageSetting) {
  if (file.isImage && file.imageSettings.process) {
    settings[file.name] = {
        width: file.imageSettings.width || globalImageSetting['width'],
        height: file.imageSettings.height || globalImageSetting['height'],
        format: file.imageSettings.format || globalImageSetting['format']

    };
  }
  return settings;
}

export const descriptionForFileType = (slug) => {
  const type = coreFileTypes.find(c => c.slug === slug);
  return type ? type.description : slug;
}
